import React, { Component } from 'react';
import {Col} from 'reactstrap';
import TrapListItem from './TrapListItem'

class TrapList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filter: '',
            trapsLoaded: true,
            trapsData: []
        };
        
        this.handleChange = this.handleChange.bind(this);
        this.update = this.update.bind(this);
    }

    componentDidMount () {
        this.update();
    }

    handleChange(event) {
        this.setState({filter: event.target.value});
    }

    update() {
        this.setState({
            trapsLoaded: false
        });

        fetch(this.props.restIp+'/traps')
            .then(function(response) {
                return response.json()
            })
            .then(function(json) {
            this.setState({
                trapsLoaded: true,
                trapsData: json,
            });
        }.bind(this)).catch(function(ex) {
            console.log('parsing failed', ex)
        });
    }

    render() {
        let rows = [];
        this.state.trapsData.forEach((trap) => {
            let id = trap.id+"";
            if (trap.title.toLowerCase().indexOf(this.state.filter.toLowerCase()) === -1 && id.indexOf(this.state.filter) === -1)
                return;

            rows.push(<TrapListItem key={trap.id} id={trap.id} selectTrap={this.props.selectTrap} restIp={this.props.restIp} refresh={this.update} title={trap.title} online={trap.online} />);
            
        });
   
        const list = <ul style={{"textDecoration": "none", "listStyle": "none", "margin": "0", "padding": "0"}}>
            {rows}
        </ul>;

        return (
            <Col id="trap_list" md="2" style={{background: 'rgb(35, 34, 35)', zIndex: 3, paddingBottom: '100px'}}>
                <input type="text" style={{display: "block"}} className={"sticky-top"} value={this.state.filter} onChange={this.handleChange} placeholder="Szukaj"/>
                {this.state.trapsLoaded ? list : <p><i className="fa fa-cog fa-spin fa-5x fa-fw" style={{margin: 'px', color: "#FFF"}}></i><span className="sr-only">Loading...</span></p>}
            </Col>
        );
    }
}

export default TrapList;


// WEBPACK FOOTER //
// ./src/components/TrapList.js